import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createBlock(_component_van_overlay, {
    show: _ctx.overlayShow,
    onClick: _cache[0] || (_cache[0] = $event => _ctx.overlayShow = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_loading, {
      size: "24px",
      color: "#5282f0",
      vertical: ""
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("加载中...")])),
      _: 1
    })])]),
    _: 1
  }, 8, ["show"]);
}